import React from 'react';
import styles from './LeadBoxSkeleton.module.scss';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
const LeadBoxSkeleton = () => {
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="LeadBoxSkeleton" data-sentry-source-file="LeadBoxSkeleton.tsx">
      <Box className={styles['skeleton-item']} data-sentry-element="Box" data-sentry-source-file="LeadBoxSkeleton.tsx">
        <Skeleton variant={'rounded'} height={24} width={24} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
        <Skeleton variant={'rounded'} height={20} width={86} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
      </Box>
      <Box className={styles['skeleton-item']} data-sentry-element="Box" data-sentry-source-file="LeadBoxSkeleton.tsx">
        <Skeleton variant={'rounded'} height={24} width={24} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
        <Skeleton variant={'rounded'} height={20} width={86} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
      </Box>
      <Box className={styles['skeleton-item']} data-sentry-element="Box" data-sentry-source-file="LeadBoxSkeleton.tsx">
        <Skeleton variant={'rounded'} height={24} width={24} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
        <Skeleton variant={'rounded'} height={20} width={86} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
      </Box>
      <Box className={styles['skeleton-item']} data-sentry-element="Box" data-sentry-source-file="LeadBoxSkeleton.tsx">
        <Skeleton variant={'rounded'} height={24} width={24} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
        <Skeleton variant={'rounded'} height={20} width={86} data-sentry-element="Skeleton" data-sentry-source-file="LeadBoxSkeleton.tsx" />
      </Box>
    </Box>;
};
export default LeadBoxSkeleton;